(() => {
  (() => {
    var _a;
    const script = document.querySelector("script[data-pb-browse-config]");
    if (!script) return;
    const root = script.dataset.collectionsUrl.replace(/\/$/, "");
    const pendingKey = "pb-browse-pending-v1";
    const restoreKey = "pb-browse-restore-v1";
    const lifetime = 60 * 60 * 1e3;
    const read = (key) => {
      try {
        return JSON.parse(sessionStorage.getItem(key) || "null");
      } catch (e) {
        return null;
      }
    };
    const write = (key, value) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
      }
    };
    const remove = (key) => {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
      }
    };
    const local = (value) => {
      try {
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin) return null;
        return url;
      } catch (e) {
        return null;
      }
    };
    const address = (url) => url.pathname + url.search + url.hash;
    const identity = (value) => {
      const url = local(value);
      if (!url) return "";
      url.searchParams.delete("preview_theme_id");
      url.searchParams.delete("_fd");
      url.searchParams.delete("pb");
      return address(url);
    };
    const sourceKind = (url) => {
      if (!url) return "";
      const path = url.pathname.replace(/\/$/, "");
      if (path === root) return "collections";
      if ((path === root + "/all-products" || path === root + "/all") && !url.searchParams.get("view")) return "products";
      return "";
    };
    const validOrigin = (value) => value && Date.now() - value.time < lifetime && Date.now() >= value.time && sourceKind(local(value.url)) === value.kind && Number.isFinite(value.y) && value.y >= 0;
    const snapshot = (kind) => {
      var _a2;
      return {
        url: address(new URL(location.href)),
        kind,
        y: window.scrollY,
        time: Date.now(),
        tileX: ((_a2 = document.querySelector(".pb-shop-nav__track")) == null ? void 0 : _a2.scrollLeft) || 0
      };
    };
    let origin = null;
    const pending = read(pendingKey);
    if (pending && Date.now() - pending.time < 12e4 && identity(pending.target) === identity(location.href) && validOrigin(pending.origin)) {
      origin = pending.origin;
      remove(pendingKey);
    } else if (validOrigin((_a = history.state) == null ? void 0 : _a.pbBrowseOrigin)) {
      origin = history.state.pbBrowseOrigin;
    } else {
      const referrer = local(document.referrer);
      const kind = sourceKind(referrer);
      if (kind && !sourceKind(local(location.href))) origin = { url: address(referrer), kind, y: 0, tileX: 0, time: Date.now() };
    }
    if (origin && !sourceKind(local(location.href))) {
      const state = history.state && typeof history.state === "object" ? history.state : {};
      history.replaceState({ ...state, pbBrowseOrigin: origin }, "");
    }
    document.querySelectorAll("[data-pb-browse-back]").forEach((link) => {
      if (!validOrigin(origin)) return;
      link.href = origin.url;
      link.querySelector("[data-pb-browse-label]").textContent = origin.kind === "collections" ? link.dataset.collectionsLabel : link.dataset.productsLabel;
    });
    document.addEventListener("click", (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest("a[href]");
      if (!link || link.target === "_blank" || link.hasAttribute("download")) return;
      const destination = local(link.href);
      if (!destination) return;
      if (link.matches("[data-pb-browse-back]")) {
        if (validOrigin(origin)) write(restoreKey, { ...origin, time: Date.now() });
        return;
      }
      if (!destination.pathname.startsWith(root + "/")) return;
      const kind = sourceKind(local(location.href));
      const context = kind ? snapshot(kind) : origin;
      if (validOrigin(context) && !sourceKind(destination)) {
        write(pendingKey, { target: address(destination), origin: context, time: Date.now() });
      }
    }, true);
    const drawer = document.getElementById("pb-collections-drawer");
    if (drawer) {
      const sync = (expanded) => document.querySelectorAll("[data-pb-collections-open]").forEach((trigger) => trigger.setAttribute("aria-expanded", String(expanded)));
      drawer.addEventListener("theme-drawer:open", () => sync(true));
      drawer.addEventListener("theme-drawer:close", () => sync(false));
      document.addEventListener("click", (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const trigger = event.target.closest("[data-pb-collections-open]");
        if (trigger && typeof drawer.open === "function") {
          event.preventDefault();
          drawer.open();
        }
      });
    }
    const restore = read(restoreKey);
    if (validOrigin(restore) && identity(restore.url) === identity(location.href)) {
      remove(restoreKey);
      let cancelled = false;
      const timers = [];
      const stop = () => {
        cancelled = true;
        timers.forEach(clearTimeout);
        window.removeEventListener("wheel", stop);
        window.removeEventListener("touchstart", stop);
        window.removeEventListener("keydown", stop);
        window.removeEventListener("pointerdown", stop);
      };
      const place = () => {
        if (cancelled) return;
        window.scrollTo({ top: restore.y, behavior: "instant" });
        const track = document.querySelector(".pb-shop-nav__track");
        if (track && Number.isFinite(restore.tileX)) track.scrollLeft = restore.tileX;
      };
      ["wheel", "touchstart", "keydown", "pointerdown"].forEach((type) => window.addEventListener(type, stop, { passive: true }));
      [0, 100, 300, 700, 1400].forEach((delay) => timers.push(setTimeout(place, delay)));
      timers.push(setTimeout(stop, 1800));
    }
  })();
})();
